import React, { useState, useEffect } from 'react';

//****************Componentes PrimeReact******************************* */
import { TabView, TabPanel } from 'primereact/tabview'


//*******************Componentes Especificos*********************************** */

import ProveedoresScreen from './ProveedoresScreen';
import ProveedoresCAIScreen from './ProveedoresCAI/ProveedoresCAIScreen';
const ListoProveedoresScreen = ({Finanzas = false}) => {

    const [activeIndex, setActiveIndex] = useState(0)
    return (
        <div className='p-2'>
            <TabView className='col-12 homeTabView' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header='Proveedores Compras' Finanzas = {Finanzas}>
                    <ProveedoresScreen />
                </TabPanel>
                <TabPanel header='Proveedores CAI'>
                    <ProveedoresCAIScreen />
                </TabPanel>
                <TabPanel header='Proveedores Varios' >
                    <ProveedoresScreen IsVarios = {true} Finanzas = {Finanzas}/>
                </TabPanel>
            </TabView>
        </div>
    )
}

export default ListoProveedoresScreen
